(function () {
    'use strict';

    /* @ngdoc object
     * @name aeroLineCrew
     * @description
     *
     */
    angular
        .module('aeroLineCrew', [
                 'ui.router',
                 'ct.ui.router.extras',
                 'ngMessages',
                 'ngAnimate',
                 'in-viewport',
                 'ui.bootstrap',
                 'ngIdle',
                 'cfp.hotkeys',
                 'ui.bootstrap.contextMenu',
                 'LocalStorageModule',
                 'angular.panels',
                 'home',
                 'authentication',
                 'commons',
                 'crewing',
                 'greatCircleDistance',
                 'flightCargo',
                 'flightPunctuality',
                 'messageInbox',
                 'flightWatch',
                 'managePairing',
                 'createPairing',
                 'crewSchedule',
                 'crewProfile',
                 'trainingSchedule',
                 'uiSwitch',
                 'ngScrollable',
                 'scrollable-table',
                 'toastr',
                 'ui.mask',
                 'ngDragDrop',
                 'trainingPrograms',
                 'tracking',
                 'fuel',
                 'rx',
                 'autoRosterSchedule',
                 'documentManager',
                 'adminCrewBatchers',
                 'aircraftRegistration',
                 'message',
                 'manageUser',
                 'manageRoles',
                 'ngPassword',
                 'crewValidation',
                 'airport',
                 'cycle',
                 'cosmicRadiation',
                 'angularSpectrumColorpicker',
                 'configureTrackingColor',
                 'trainingDiscrepancy',
                 'patternLimitation',
                 'renewals',
                 'manageFlight',
                 'patternLimitation',
                 'renewals',
                 'hardSoftRule',
                 'configDistribution',
                 'applicationParameters',
                 'bidding',
                 'dutySheet',
                 'print',
                 'targetHours',
                 'indiCrewExpiryLog',
                 'individualCrewExpiryReport',
                 'activeInactiveCrewList',
                 'crewPositionsReport',
                 'electronicLogBook' ,
                 'dutySheet',
                 'print',
                 'targetHours',
                 'individualCrewScheduleReport',
                 'flyingScheduleReport',
                 'crewingReport',
                 'messageAdmin',
                 'generalFlightReport',
                 'paxMessage',
                 'paxMessageConfig',
                 'missingSignIn',
                 'flightInformationReport',
                 'baseWiseLayoverReport',
                 'crewBaseAssignmentReport',
                 'otpReport',
                 'dailyOpsReport',
                 'flightDelayReport',
                 'flightBlockTimeReport',
                 'flightPaxCountReport',
                 'performanceDetailReport',
                 'crewSetReport',
                 'acUtilizationReport',
                 'leaveDetailReport',
                 'fuelPriceReport',
                 'deadHeadingReport',
                 'crewSalesReport',
                 'etsReport',
                 'leaveReport',
                 'crewDownloads',
                 'appFileDownload',
                 'fuelBurnDiscrepancy',
                 'cabinFlightIssues',
                 'missingEtsReport',
                 'missingPatternsReport',
                 'crewHourReport',
                 'rosterStability',
                 'missingPatternsReport',
                 'crewExpiryLogReport',
                 'crewAirportExpiryReport',
                 'crewWaterConsumption',
                 'cabinPerformanceComment',
                 'crewSignInReport',
                 'requestRespectedReport',
                 'fdpViolationReport',
                 'seniorityList',
                 'crewFlyingExperiance',
                 'rosterChecking',
                 'flyingHoursAllowance',
                 'slipAllowanceReport',
                 'alvBidding',
                 'crewPunctualityReport',
                 'cabinPerformance',
                 'monthlyFlightTime',
                 'welcome',
                 'crewFlyingDetailsReport',
                 'crewCreditHoursReport',
                 'payment',
                 'paymentPlannedActual',
                 'paymentRates',
                 'acarsMessages',
                 'flightReports',
                 'voyageReport',
                 'cabinFlightAdmin',
                 'trainingAllowanceReport',
                 'individualFlyingHours',
                 'flyingHourSummaryReport',
                'sageFlightDataReport',
                 'trainingRoster',
                 'trainingAuditReport',
                 'userActivityAuditReport',
                 'trainingCostReport',
                 'mealDetail',
                 'notificationsLog',
                 'userActivityReport',
                 'trackingDiscrepancy',
                 'languageDiscrepancy',
                 'ngHandsontable',
                 'maleFemaleDiscrepancy',
                 'crewSignInScreen',
                 'flightScreen',
                 'smsManager',
                 'crewViolations',
                 'ui.tinymce',
                 'cosmicRadiationReport',
                 'atcCallSign',
                 'operationsSummaryReport',
                 'rosterScoringReport',
                 'snap',
                 'pairingCompliments',
                 'adminCommanderDiscretion',
                  'crewStandByReport',
                  'crewPairingReport',
                  'annualLeaveBidding',
                 'consecutiveDayFlightAndEarlyMorningDeparture',
                  'crewStandByReport',
                  'doubleSectorInRollingSevenDays',
                  'morningFlightAfterNightFlight',
                  'minRestBreachPriorToRktDeparture',
                  'multipleFlightsInRollingSevenDays',
                  'doubleSectorCount',
                  'morningFlightPriorToLayoverNight',
                  'doubleSectorPriorToDayTurnaround',
                  'payrollDutySummary',
                  'rosterStatusReportRadarChart',
                  'salesTarget',
                  'pairingAssignmentComplementConfirmationModal',
                  'stationFlightHandling',
                  'mapPairingGroups',
                  'simUtilizationReport',
                  'layoverSummaryReport',
                  'crewScheduleChangeReport',
                  'fdpExceedanceReport',
                  'crewVoyageReport',
                  'crewHotacReport'
        ]);
}());
